<template>
  <vx-card>
    <div slot="no-body" class="tabs-container px-6 pt-6">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label for="" style="font-size:13px" class="ml-1">{{$t('adminUserICon.account')}}</label>
          <vs-input
          v-model="account"
          type="text"
          class="w-full"
          name="account"
          v-validate ="'required'"
          data-vv-validate-on="blur"
          ></vs-input>
          <span class="text-danger text-sm">{{
                errors.first("account")
              }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label for="" class="ml-1" style="font-size:13px"> {{$t('adminUserICon.pass')}}</label>
          <vs-input
          v-model="password"
          type="text"
          class="w-full"
          name="account"
          v-validate ="'required'"
          data-vv-validate-on="blur"
          ></vs-input>
          <span class="text-danger text-sm">{{
                errors.first("password")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">{{$t('adminUserICon.type')}}</label>
          <vs-select
          v-model="type"
          class="w-full"
          name="type"
          >
            <vs-select-item v-for="(item,index) in optionalType" :key="index" :value="item.value" :text="item.label"></vs-select-item>
          </vs-select>
          <span class="text-danger text-sm">{{
                errors.first("type")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">{{$t('adminUserICon.accountStatus')}}</label>
          <vs-select
          v-model="used"
          class="w-full"
          name="type"
          >
            <vs-select-item v-for="(item,index) in optionalUsed" :key="index" :value="item.value" :text="item.label"></vs-select-item>
          </vs-select>
          <span class="text-danger text-sm">{{
                errors.first("type")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">{{$t('adminUserICon.effect')}}</label>
          <vs-select
          v-model="valid"
          class="w-full"
          name="type"
          >
            <vs-select-item v-for="(item,index) in optionalValid" :key="index" :value="item.value" :text="item.label"></vs-select-item>
          </vs-select>
          <span class="text-danger text-sm">{{
                errors.first("type")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">Token</label>
          <vs-input
          class="w-full"
          v-model="accessToken"
          ></vs-input>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">{{$t('adminUserICon.creatorCode')}}</label>
          <vs-input
          class="w-full"
          v-model="pidUsed"
          ></vs-input>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-2 mb-2">
          <label class="ml-1" style="font-size:13px" for="">{{$t('adminUserICon.creator')}}</label>
          <vs-input
          class="w-full"
          v-model="lastUsedBy"
          ></vs-input>
        </div>

      </div>
      <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
                  $t('adminUserICon.update'): $t('adminUserICon.create')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">{{$t('adminUserICon.back')}}
                </vs-button>
              </div>
            </div>
          </div>
    </div>
  </vx-card>
</template>
<script>
export default {
  components:{

  },
  data(){
    return{
      account:null,
      password:null,
      isUpdate:false,
      used:null,
      valid:null,
      accessToken:null,
      pidUsed:null,
      lastUsedBy:null,
      optionalUsed:[
        {label:'Chưa sử dụng',value:0},
        {label:'Đã sử dụng',value:1}
      ],
      type:null,
      optionalType:[
        {label:'Bình thường',value:0},
        {label:'Ưu tiên', value:1}
      ],
      optionalValid:[
        {label:'Không hiệu lực',value:0},
        {label:'Có hiệu lực', value:1}
      ]
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    }
  },
  methods:{
    checkOptionalUsed : function () {
      this.optionalUsed[0].label = this.$t('adminUserICon.notUsedYet')
      this.optionalUsed[1].label = this.$t('adminUserICon.wasUsed')
    },
    checkOptionalType : function () {
      this.optionalType[0].label = this.$t('adminUserICon.normal')
      this.optionalType[1].label = this.$t('adminUserICon.prioritize')
    },
    checkOptionalValid : function () {
      this.optionalValid[0].label = this.$t('adminUserICon.notEffective')
      this.optionalValid[1].label = this.$t('adminUserICon.effective')
    },
    saveChanges:function(){
      if(!this.validateForm) return;
      const payloadCreate = [{
        account:this.account,
        password:this.password,
        type:this.type,
        used:this.used ? true:false,
        valid:this.valid ? true:false,
        accessToken: this.accessToken,
        pidUsed:this.pidUsed,
        lastUsedBy: this.lastUsedBy
      }]

      const payloadUpdate = {
        account:this.account,
        password:this.password,
        type:this.type,
        used:this.used ? true:false,
        valid:this.valid ? true:false,
        accessToken: this.accessToken,
        pidUsed:this.pidUsed,
        lastUsedBy: this.lastUsedBy
      }
      const payload = this.isUpdate ? payloadUpdate : payloadCreate;
      const path = this.isUpdate ? '/account-data/update' : '/account-data/create-list';
      this.$processor.post(path,payload).then((res) =>{
        this.$vs.notify({
          text:`Thêm mới tài khoản thành công`,
          icon: 'feather',
          iconPack:'icon-alert',
          color: 'primary'
        });
        this.$router.push('/admin/account-views').catch(() =>{});
      }).catch((err) =>{
        this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
      })
    },
    initScreen: function(){
      this.account = this.$route.query.uid;
      const payload ={
        account: this.account
      }
      if(this.account){
        this.$processor.post('/account-data/find-by-id',payload).then((res)=>{
        this.isUpdate = true;
        let data = res.data;
        this.account = data.account;
        this.password = data.password;
        this.used = data.used ? 1 : 0,
        this.valid = data.valid ? 1 : 0
        this.pidUsed= data.pidUsed;
        this.lastUsedBy = data.lastUsedBy;
        if(data.type == "Normal"){
          this.type = 0
        }
        else{
          this.type = 1;
        }
        this.accessToken = data.accessToken
      }).catch(()  =>{})
      }
    }
  },

  async created(){
    this.initScreen();
    this.$eventBus.$on('i18n' , (event) => {
      this.checkOptionalType();
      this.checkOptionalUsed();
      this.checkOptionalValid();
    })
    this.checkOptionalType();
    this.checkOptionalUsed();
    this.checkOptionalValid();
  }
}
</script>
<style scoped>

</style>
